import ahsanSajidImage from "@/assets/ahsan-sajid.png";
export const NoCodeFounderQuote = () => (
  <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
    <div className="flex items-start gap-4">
      <img src={ahsanSajidImage} alt="Ahsan Sajid" className="w-14 h-14 rounded-full object-cover border-2 border-primary/20" />
      <div>
        <blockquote className="text-foreground italic leading-relaxed">
          "No-code is powerful for the right use cases. Internal dashboards, landing pages, MVPs? Perfect. 
          But when you need custom integrations, complex logic, or real scale? That's where traditional 
          development shines. The smartest approach uses both: no-code for speed, custom code for competitive advantage."
        </blockquote>
        <div className="mt-4">
          <p className="font-semibold text-foreground">Ahsan Sajid</p>
          <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
        </div>
      </div>
    </div>
  </div>
);
